import Vue from "vue";
import VueRouter from "vue-router";
import SiteHome from "../modules/site/pages/IndexPage.vue";
import PoliticaPage from "../modules/site/pages/PoliticaPage.vue";
import TermosPage from "../modules/site/pages/TermosPage.vue";
import SobrePage from "../modules/site/pages/SobrePage.vue";
import LoginPage from "../modules/auth/loginPage.vue";
import CadastroPage from "../modules/auth/cadastroPage.vue";
import InicioPage from "../modules/dashboard/pages/InicioPage.vue";
import authService from "../services/auth";
import api from "../services/api";
import ListagemMotorista from "../modules/motoristas/listagemMotorista.vue";
import ListagemUsuarios from "../modules/usuarios/listagemUsuarios.vue";
import ListagemPlanos from "../modules/planos/indexPlanos.vue";
import ListagemVeiculos from "../modules/veiculos/listagemVeiculos.vue";
import CadastroVeiculo from "../modules/veiculos/cadastroVeiculo.vue";
import EditarVeiculo from "../modules/veiculos/editarVeiculo.vue";
import DocumentacaoVeiculo from "../modules/veiculos/documentacaoVeiculo.vue";
import MapaPneusVeiculo from "../modules/veiculos/mapaPneusVeiculo.vue";
import ListagemManutencoesVeiculos from "../modules/manutencoesVeiculos/listagemManutencoesVeiculos.vue";
import ListagemMultasVeiculos from "../modules/multasVeiculos/listagemMultasVeiculos.vue";
import ListagemViagens from "../modules/viagens/listagemViagens.vue";
import IndexCtesMdfe from "../modules/ctesMdfe/indexCtesMdfe.vue";
import ListagemFinanceiro from "../modules/financeiro/listaFinanceiro.vue";
import ListagemEmpresas from "../modules/empresas/listagemEmpresas.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "site",
    component: SiteHome,
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/modules/blog/listaBlog.vue'),
    meta: { title: 'Blog - CargaZap' }
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: () => import('@/modules/blog/postBlog.vue'),
  },
  {
    path: "/politica-de-privacidade",
    name: "politica",
    component: PoliticaPage,
  },
  {
    path: "/termos-de-uso",
    name: "termos",
    component: TermosPage,
  },
  {
    path: "/sobre",
    name: "sobre",
    component: SobrePage,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/cadastro",
    name: "cadastro",
    component: CadastroPage,
  },
  {
    path: "/motoristas",
    name: "Listagem de Motoristas",
    component: ListagemMotorista,
    meta: { requiresAuth: true }
  },
  {
    path: "/veiculos",
    name: "ListagemVeiculos",
    component: ListagemVeiculos,
    meta: { requiresAuth: true }
  },
  {
    path: "/veiculos/novo",
    name: "CadastroVeiculo",
    component: CadastroVeiculo,
    meta: { requiresAuth: true }
  },
  {
    path: "/veiculos/:id/editar",
    name: "EditarVeiculo",
    component: EditarVeiculo,
    meta: { requiresAuth: true }
  },
  {
    path: "/veiculos/documentacao",
    name: "DocumentacaoVeiculo",
    component: DocumentacaoVeiculo,
    meta: { requiresAuth: true }
  },
  {
    path: "/veiculos/:id/mapa-pneus",
    name: "MapaPneusVeiculo",
    component: MapaPneusVeiculo,
    meta: { requiresAuth: true }
  },
  {
    path: "/manutencoes-veiculos",
    name: "ListagemManutencoesVeiculos",
    component: ListagemManutencoesVeiculos,
    meta: { requiresAuth: true }
  },
  {
    path: "/multas-veiculos",
    name: "ListagemMultasVeiculos",
    component: ListagemMultasVeiculos,
    meta: { requiresAuth: true }
  },
  {
    path: "/viagens",
    name: "ListagemViagens",
    component: ListagemViagens,
    meta: { requiresAuth: true }
  },
  {
    path: "/ctes-mdfe",
    name: "CtesMdfe",
    component: IndexCtesMdfe,
    meta: { requiresAuth: true }
  },
  {
    path: "/financeiro",
    name: "ListagemFinanceiro",
    component: ListagemFinanceiro,
    meta: { requiresAuth: true }
  },
  {
    path: "/empresas",
    name: "ListagemEmpresas",
    component: ListagemEmpresas,
    meta: { requiresAuth: true }
  },
  {
    path: "/usuarios",
    name: "Listagem de Usuários",
    component: ListagemUsuarios,
    meta: { requiresAuth: true }
  },
  {
    path: "/planos",
    name: "Planos do Sistema",
    component: ListagemPlanos,
    meta: { requiresAuth: true }
  },
  {
    path: "/inicio",
    name: "inicio",
    component: InicioPage,
    meta: { requiresAuth: true }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta?.requiresAuth);
  const isAuthenticated = authService.isAuthenticated();

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } });
  }

  if (requiresAuth && to.path !== '/planos') {
    try {
      const { data } = await api.get('/assinaturas/atual');

      if (!data || data.acesso_liberado === false) {
        return next({ path: '/planos', query: { redirect: to.fullPath } });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        return next({ name: 'login', query: { redirect: to.fullPath } });
      }
    }
  }

  next();
});

export default router;
